<template>
    <div class="popup" v-cloak v-if="subAccountShow" >
        <div class="content" id="subAccount">
            <div class="title">
                <span>{{$t('language.popup.subAccountPopup.title')}}</span>
                <div class="icon white-close dialog-close" @click="classesOfDialog()"></div>
            </div>
            <div ref="tab" class="sub-account-body" v-loading="loading">
                <el-tabs v-model="tabName">
                    <el-tab-pane :label="$t('language.popup.subAccountPopup.tabNameUser')" name="first">
                        <tab1 ref="usersTab" :disable="disable" v-on:openSubAccountPopup="openSubAccountPopup" :allPermissionData="allPermissionData"></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.subAccountPopup.tabNameItem')" name="second">
                        <tab2 ref="itemsTab" :disable="disable" v-on:openSubAccountPopup="openSubAccountPopup" :allPermissionData="allPermissionData"></tab2>
                    </el-tab-pane>
                </el-tabs>
            </div>
        <editSubAccountDialog ref="editSubAccount"></editSubAccountDialog>
        <addUserSubAccountDialog ref="addUserSubAccount"></addUserSubAccountDialog>
        <addItemSubAccountDialog ref="addItemSubAccount"></addItemSubAccountDialog>
        <cancelSubAccountDialog ref="cancelSubAccount"></cancelSubAccountDialog>
        <batchAddSubAccountDialog ref="batchAddSubAccount" :allPermissionData="allPermissionData"></batchAddSubAccountDialog>
        <errorPopupDialog ref="errorPopup"></errorPopupDialog>
        </div>
    </div>
</template>
<script>
import commonstate from '@/js/constant.js';
import tab1 from "@/components/common/tabs/tabs_sub_account/tab_users";
import tab2 from "@/components/common/tabs/tabs_sub_account/tab_items";
import editSubAccountDialog from "@/components/popup/sub_account_popups/edit_user_popup";
import addUserSubAccountDialog from "@/components/popup/sub_account_popups/add_user_popup";
import addItemSubAccountDialog from "@/components/popup/sub_account_popups/add_item_popup";
import cancelSubAccountDialog from "@/components/popup/sub_account_popups/cancel_popup";
import batchAddSubAccountDialog from "@/components/popup/sub_account_popups/batch_add_popup";
import errorPopupDialog from "@/components/common/error_popup.vue";
export default {
    components: {
        tab1,
        tab2,
        disable: false,
        editSubAccountDialog,
        addUserSubAccountDialog,
        addItemSubAccountDialog,
        cancelSubAccountDialog,
        batchAddSubAccountDialog,
        errorPopupDialog,
    },
    data: function () {
        return {
            tabName: "first",
            subAccountShow: false,
            disable: false,
            allPermissionData: [],//权限列表
            loading:false,
        };
    },
    watch: {
        subAccountShow(val) {
            if(val){
                this.getPermissionList();
            }
        }
    },
    methods: {
        classesOfDialog(){
            this.subAccountShow = false;
            this.loading = false;
        },
        //打开弹窗
        openSubAccountPopup(type,item){
            switch (type) {
                case "editUser":
                    this.openEditSubAccountPopup(item);
                    break;
                case "addUser":
                    this.openAddUserSubAccountPopup(item);
                    break;
                case "addItem":
                    this.openAddItemSubAccountPopup(item);
                    break;
                case "delete":
                    this.openCancelSubAccountPopup(item);
                    break;
                case "batchAddUser":
                    this.openBatchAddUserSubAccountPopup(item);
                    break;
                case "batchAddItem":
                    this.openBatchAddItemSubAccountPopup(item);
                    break;
                default:
                    break;
            }
        },
        //打开修改用户弹窗
        openEditSubAccountPopup(sub){
            if(sub.id){
                this.$refs.editSubAccount.editSubAccountShow = true;
                this.$refs.editSubAccount.subAccountId = sub.id;
                this.$refs.editSubAccount.subAccountName = sub.email;
            }else{
                this.$toast({
                    text: this.$t('language.common.failure'),
                    type: 'fail',
                    idValue: "subAccount",
                });
            }
        },
        //打开添加用户弹窗
        openAddUserSubAccountPopup(item){
            if((item==null||item=="")&&this.tabName=="second"){
                this.$refs.errorPopup.show = true;
                this.$refs.errorPopup.title = this.$t('language.popup.subAccountPopup.addUser.title');
                this.$refs.errorPopup.message = this.$t('language.popup.subAccountPopup.noItemFromAddUser');
                return;
            }
            this.$refs.addUserSubAccount.addUserSubAccountShow = true;
            this.$refs.addUserSubAccount.folderItem = item;
        },
        //打开添加文件弹窗
        openAddItemSubAccountPopup(item){
            if((item==null||item=="")&&this.tabName=="first"){
                this.$refs.errorPopup.show = true;
                this.$refs.errorPopup.title = this.$t('language.popup.subAccountPopup.addItemButton');
                this.$refs.errorPopup.message = this.$t('language.popup.subAccountPopup.noUserFromAddItem');
                return;
            }
            this.$refs.addItemSubAccount.addItemSubAccountShow = true;
            let that = this;
            this.$nextTick(()=>{
                that.$refs.addItemSubAccount.$refs.subAddItemScroll.moveY = 0;
                that.$refs.addItemSubAccount.$refs.subAddItemScroll.$refs.wrap.scrollTop=0;
            });
            this.$refs.addItemSubAccount.subAccountEmail = item;//是否直接绑定email
            this.$refs.addItemSubAccount.initData();//初始化文件列表
        },
        //打开删除弹窗
        openCancelSubAccountPopup(item){
            if(item.delItem){
                this.$refs.cancelSubAccount.delItem = item.delItem;//删除账号
                this.$refs.cancelSubAccount.isUser = item.isUser;//是否是删除账号
                this.$refs.cancelSubAccount.cancelType = item.type;//删除类型
                this.$refs.cancelSubAccount.cancelShow = true;
            }else{
                this.$toast({
                    text: this.$t('language.common.failure'),
                    type: 'fail',
                    idValue: "subAccount",
                });
            }
        },
        //获取权限列表
        getPermissionList(){
            this.loading = true;
            this.Utils.doPermissionRequest("load_all_limits", {ud: commonstate.user.id}).then(res => {
                this.loading = false;
                if(res.status=="200"){
                    this.allPermissionData = res.list;
                }else{
                    this.allPermissionData = [];
                }
            })
        },
        //打开添加用户弹窗
        openBatchAddUserSubAccountPopup(item){    
            if((item==null||item=="")&&this.tabName=="second"){
                this.$refs.errorPopup.show = true;
                this.$refs.errorPopup.title = this.$t('language.popup.subAccountPopup.quickAdd');
                this.$refs.errorPopup.message = this.$t('language.popup.subAccountPopup.noItemFromAddUser');
                return;
            }
            this.$refs.batchAddSubAccount.addUserShow = true;
            this.$refs.batchAddSubAccount.addItem = item;
        },
        //打开添加文件弹窗
        openBatchAddItemSubAccountPopup(item){
            if((item==null||item=="")&&this.tabName=="first"){
                this.$refs.errorPopup.show = true;
                this.$refs.errorPopup.title = this.$t('language.popup.subAccountPopup.quickAssign');
                this.$refs.errorPopup.message = this.$t('language.popup.subAccountPopup.noUserFromAddItem');
                return;
            }
            this.$refs.batchAddSubAccount.addItemShow = true;
            this.$refs.batchAddSubAccount.addItem = item;
        },
    }
}
</script>

<style>
#subAccount {
    width: 850px;
    /*no*/
    height: 500px;
    /*no*/
}

.subAccount-content {
    width: 100%;
    box-sizing: border-box;
    padding: 20px; /*no*/
    color: #6f7886;
    height: 91%; /*no*/
    overflow: auto;
}

.sub-account-body {
    margin: 0 20px;/*no*/
}

#subAccount #tab-first,#subAccount #tab-second {
    font-size: 14px;/*no*/
    height: 45px;/*no*/
    line-height: 45px;/*no*/
    padding: 5px 20px 0 0;/*no*/
}

.popup #subAccount .popup {
    z-index: 600;
}

#subAccount .el-tabs__item:focus.is-active.is-focus:not(:active) {
    -webkit-box-shadow: none;
    box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/sub_account_popup.vue